import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["name", "description", "id", "type", "categories", "duration", "numberOfLessons", "badge", "onClick", "href", "footerHref", "thumbnailUrl", "to", "showFooter"];
import { getDisplayCategories } from 'academy-common-lib/utils/categories';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import ACContentCard from 'academy-common-lib/components/card/ACContentCard';
import ACThumbnailOverlay from 'academy-common-lib/components/card/ACThumbnailOverlay';
import FormattedDuration from 'I18n/components/FormattedDuration';
import { Button } from 'foundations-components/transitional/components/Button';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { resize } from 'FileManagerCore/utils/resize';
import { getLocationDescriptor } from '../../../utils/routing';
import usageTracker from '../../../utils/usageTracker';
import { getMarketingThemePreference } from '../../../utils/themeUtils';
import ACContentCardLarge from 'academy-common-lib/components/card/ACContentCardLarge';
import { getReactRouterHref } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const START_CTA_MESSAGES = {
  COURSE: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentCard.startCta.course"
  }),
  CERTIFICATION: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentCard.startCta.certification"
  }),
  LESSON: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentCard.startCta.lesson"
  })
};
const BADGE_MESSAGES = {
  POPULAR: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentCard.badge.popular"
  }),
  NEW: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentCard.badge.new"
  }),
  UPDATED: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentCard.badge.updated"
  })
};
const renderLessonCount = numberOfLessons => /*#__PURE__*/_jsxs(Flex, {
  alignItems: "center",
  children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
    "data-test-id": "track-total-lessons",
    message: "academyPublic.contentCard.numLessonsRemainingUnstarted",
    options: {
      remainingNumber: numberOfLessons
    }
  }), /*#__PURE__*/_jsx(View, {
    as: "span",
    blockSize: "10px",
    borderColor: "border-core-default",
    borderInlineEndStyle: "solid",
    borderInlineEndWidth: "100",
    marginInline: "300"
  })]
});
const PublicContentCard = _ref => {
  let {
      name,
      description,
      id,
      type,
      categories,
      duration,
      numberOfLessons,
      badge,
      onClick,
      href,
      footerHref,
      thumbnailUrl,
      to,
      showFooter = true
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const resizedThumbnailUrl = thumbnailUrl ? resize(thumbnailUrl, {
    length: 400
  }) : undefined;
  const buttonHref = footerHref || href;
  const isMarketingThemeEnabled = getMarketingThemePreference();
  if (isMarketingThemeEnabled) {
    return /*#__PURE__*/_jsx(ACContentCardLarge, {
      contentHref: href ? getReactRouterHref(href) : undefined,
      contentType: type,
      imageSrc: resizedThumbnailUrl || '',
      length: duration || 0,
      lengthType: "time",
      linkMode: "react-router",
      name: name,
      onLinkClick: () => {
        usageTracker.track('interaction', {
          action: 'click-content-card',
          value: href
        });
        onClick === null || onClick === void 0 || onClick();
      },
      ribbonText: badge && BADGE_MESSAGES[badge],
      ribbonUse: badge === 'NEW' ? 'new' : 'koala',
      tags: getDisplayCategories(categories).map(categoryKey => /*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyCommon.categories.${categoryKey}`
      }, categoryKey))
    });
  }
  return /*#__PURE__*/_jsx(ACContentCard, Object.assign({
    description: description,
    footer: showFooter && buttonHref && /*#__PURE__*/_jsx(Button, {
      block: true,
      href: buttonHref,
      onClick: e => {
        e.stopPropagation();
        usageTracker.track('interaction', {
          action: 'click-start-content-card',
          value: buttonHref
        });
      },
      use: "tertiary",
      children: START_CTA_MESSAGES[type]
    }),
    href: href,
    id: id,
    name: name,
    onClick: onClick,
    style: {
      maxWidth: 400
    },
    thumbnailOverlay: /*#__PURE__*/_jsx(ACThumbnailOverlay, {
      badge: badge && BADGE_MESSAGES[badge],
      categories: getDisplayCategories(categories),
      contentType: type,
      footer: /*#__PURE__*/_jsxs(Flex, {
        children: [numberOfLessons && renderLessonCount(numberOfLessons), duration && /*#__PURE__*/_jsx(FormattedDuration, {
          format: "medium",
          from: +new Date() - duration * 1000
        })]
      }),
      children: badge && /*#__PURE__*/_jsx(Badge, {
        insetBlockStart: "300",
        insetInlineEnd: "300",
        position: "absolute",
        use: "koala",
        children: BADGE_MESSAGES[badge]
      })
    }),
    thumbnailSrc: resizedThumbnailUrl,
    to: getLocationDescriptor(to)
  }, restProps));
};
export default PublicContentCard;